import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  API,
  fetcher,
  Pagination,
  PaginationResponse,
} from "@/shared/core-configs";
import qr from "query-string";
import { ProductAdjustment } from "../types/ProductAdjustment";

export const GET_PRODUCT_ADJUSTMENTS_FETCH_KEY =
  "@CORE_PRODUCTS_GET_PRODUCT_ADJUSTMENTS_KEY";

export type ProductAdjustmentFilters = {
  productAdjustmentTypeId?: string;
  storageId?: string;
  dateFrom?: string;
  dateTo?: string;
};

type GetProductAdjustmentsParams = {
  zoneId?: string;
  searchTerm?: string;
  showDisabled?: boolean;
  filters?: ProductAdjustmentFilters;
} & Partial<Pagination>;

export const getProductAdjustments = async (
  zoneId?: string,
  page = 1,
  pageSize = 10,
  searchTerm?: string,
  showDisabled?: boolean,
  filters?: ProductAdjustmentFilters,
) => {
  const params = qr.stringify({
    zoneId,
    page,
    pageSize,
    searchTerm,
    showDisabled,
    ...filters,
  });
  const response = await fetcher.get(
    `${API.GESLUB_SERVICE}/product-adjustments?${params}`,
  );
  return response.data;
};

export const useGetProductAdjustments = ({
  zoneId,
  page,
  pageSize,
  searchTerm,
  showDisabled,
  filters,
}: GetProductAdjustmentsParams = {}) => {
  const { data, error, isPending, refetch } = useQuery<
    PaginationResponse<ProductAdjustment>,
    Error
  >({
    queryKey: [
      GET_PRODUCT_ADJUSTMENTS_FETCH_KEY,
      zoneId,
      page,
      pageSize,
      searchTerm,
      showDisabled,
      filters,
    ],
    queryFn: () =>
      getProductAdjustments(
        zoneId,
        page,
        pageSize,
        searchTerm,
        showDisabled,
        filters,
      ),
    placeholderData: keepPreviousData,
  });
  return {
    data: data?.data || [],
    pagination: data?.pagination,
    error,
    isPending,
    refetch,
  };
};
